<template>
    <Link @click="onClick">
        <slot :btnTitle="btnTitle"></slot>

        <!--        <Modal v-model:visible="downloadModal" :title="modalTitle" :mask-closable="false">-->
        <!--            <div class="modal-content">-->
        <!--                <div class="progress-container">-->
        <!--                    <Progress :percent="downloadPercent.toFixed(2)-0"></Progress>-->
        <!--                </div>-->
        <!--                <div class="action-container">-->
        <!--                    <Button class="btn" :class="{-->
        <!--                            loading-->
        <!--                        }" type="primary" ghost @click="onDownload">{{ btnTitle }}-->
        <!--                    </Button>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </Modal>-->
    </Link>
</template>

<script setup lang="ts">
import Link from "@/Components/Link.vue";
import {ref} from "vue";
import http from "@/utils/http";
import {notify, route} from "@/utils/common";
import JSZip from "jszip"
import {saveAs} from "file-saver"
import dayjs from "dayjs";

const downloadModal = ref(false)
const downloadPercent = ref<number>(0)
const modalTitle = ref('下载作品中，请稍候')
const btnTitle = ref('免费下载')

const props = defineProps<{
    work: any,
}>()

const loading = ref(false)
let zip
let zipContent

const onClick = async () => {
    if (loading.value) {
        return
    }

    if (zipContent) {
        await onDownload()
        return
    }

    try {
        btnTitle.value = '下载中'
        const createjs = await import("preload-js")

        modalTitle.value = '下载作品中，请稍候'
        const res = await http.get(route('api.work.getDownloadUrl', {work: props.work.id}))
        zip = new JSZip()
        loading.value = true
        downloadPercent.value = 0

        downloadModal.value = true

        const loader = new createjs.LoadQueue(true)
        loader.on('progress', event => {
            downloadPercent.value = event.progress * 100
            btnTitle.value = downloadPercent.value.toFixed(2) + ' %'
        })
        loader.on('fileload', event => {
            zip.file(event.item.name, event.rawResult)
        })
        res.map(file => {
            loader.loadFile({name: file.name, src: file.url, type: 'binary'})
        })

        loader.on('complete', () => {
            modalTitle.value = '下载成功，正在打包中'
            btnTitle.value = '打包中'
            zip.generateAsync({
                type: "blob",
                compression: "DEFLATE",
                compressionOptions: {level: 8}
            }).then(function (content) {
                modalTitle.value = '打包完成，请点击按钮保存'
                btnTitle.value = '重新下载'
                zipContent = content
                loading.value = false

                onClick()
            });
        })

        loader.load()

    } catch (e) {
        loading.value = false
        notify({
            message: '下载失败: ' + e.message
        })
        console.error(e)
    }
}

const onDownload = async () => {
    // see FileSaver.js
    saveAs(zipContent, props.work.name + dayjs().format('-YYYYMMDDHHmmss') + ".zip");
}
</script>

<style scoped lang="less">
.modal-content {
    padding: 10px;

    .progress-container {
        padding: 0 20px;
    }

    .action-container {
        padding: 10px;
        display: flex;
        justify-content: center;

        .btn {
            border: 1px solid #EEEEEE;
            background: #f6f6f6;

            &.loading {
                background: #fafafa;
                color: #cccccc;
                pointer-events: none;
            }
        }
    }
}
</style>
